import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function Apps({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M17.5 15V20M20 17.5H15M8 10H5C3.895 10 3 9.1 3 8V5C3 3.895 3.895 3 5 3H8C9.1 3 10 3.895 10 5V8C10 9.1 9.1 10 8 10ZM19 10H16C14.89 10 14 9.1 14 8V5C14 3.895 14.89 3 16 3H19C20.1 3 21 3.895 21 5V8C21 9.1 20.1 10 19 10ZM8 21H5C3.895 21 3 20.1 3 19V16C3 14.89 3.895 14 5 14H8C9.1 14 10 14.89 10 16V19C10 20.1 9.1 21 8 21Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default Apps;